import React from "react";

const IconTwoWayTexting = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="23" height="22" viewBox="0 0 23 22" fill="none" className={className}>
    <path
      d="M6.49023 18.5C8.15023 18.5 9.49023 17.16 9.49023 15.5C9.49023 13.84 8.15023 12.5 6.49023 12.5C4.83023 12.5 3.49023 13.84 3.49023 15.5C3.49023 17.16 4.83023 18.5 6.49023 18.5Z"
      fill="url(#paint0_linear_146_244)"
    />
    <path
      d="M5.09 10.23C5.03 9.83 5 9.42 5 9C5 4.58 8.59999 1 13.05 1C17.5 1 21.1 4.58 21.1 9C21.1 10 20.92 10.95 20.58 11.84C20.51 12.02 20.47 12.11 20.46 12.18C20.44 12.25 20.44 12.3 20.44 12.37C20.44 12.44 20.44 12.52 20.47 12.69L20.87 15.96C20.91 16.31 20.94 16.49 20.87 16.62C20.82 16.73 20.73 16.82 20.61 16.87C20.48 16.93 20.3 16.9 19.95 16.85L16.76 16.38C16.59 16.36 16.51 16.34 16.43 16.34C16.35 16.34 16.3 16.34 16.23 16.36C16.16 16.38 16.06 16.41 15.87 16.48C14.99 16.81 14.03 16.99 13.03 16.99C12.61 16.99 12.2 16.96 11.8 16.9M6.62997 21C9.58997 21 12 18.54 12 15.5C12 12.46 9.59997 10 6.62997 10C3.65997 10 1.25998 12.46 1.25998 15.5C1.25998 16.11 1.35998 16.7 1.53998 17.25C1.61998 17.48 1.64998 17.6 1.66998 17.68C1.67998 17.76 1.68999 17.81 1.67999 17.89C1.67999 17.97 1.64999 18.06 1.60999 18.24L1 21L3.98999 20.59C4.14999 20.57 4.23 20.56 4.31 20.56C4.39 20.56 4.43 20.56 4.5 20.58C4.57 20.59 4.66997 20.63 4.87997 20.7C5.42997 20.89 6.01997 21 6.62997 21Z"
      stroke="#191E49"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_146_244"
        x1="6.49023"
        y1="12.5"
        x2="6.49023"
        y2="18.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C098F5" />
        <stop offset="1" stopColor="#C098F5" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default IconTwoWayTexting;
